import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthService } from '../services/api';
import logo from '../assets/logo.png'; // Importer le logo
import Message from './Message';

const SignIn = () => {
    const [credentials, setCredentials] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await AuthService.signIn(credentials);
            navigate('/dashboard'); // Redirection vers le tableau de bord après connexion
        } catch (err) {
            console.error('Erreur de connexion:', err);
            // L'API ne distingue pas compte inconnu et mauvais mot de passe (pas d'énumération des comptes).
            const status = err.response?.status;
            setError(
                status === 401 ? 'Adresse e-mail ou mot de passe incorrect.'
                    : status === 429 ? 'Trop de tentatives de connexion. Réessayez dans quelques minutes.'
                        : 'Une erreur est survenue lors de la connexion. Veuillez réessayer.'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="signin-container">
            <img src={logo} alt="Logo de l'application" style={{ maxWidth: '150px', display: 'block', margin: '0px auto 20px auto' }} /> {/* Afficher le logo */}
            <h2>Connexion</h2>
            {error && <Message>{error}</Message>}

            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={credentials.email}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="password">Mot de passe</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        value={credentials.password}
                        onChange={handleChange}
                        required
                    />
                </div>

                <button type="submit" disabled={loading}>
                    {loading ? 'Connexion en cours...' : 'Se connecter'}
                </button>
            </form>

            <p>
                Vous n'avez pas de compte ? <Link to="/signup">Créer un compte</Link>
            </p>
            <p style={{ marginTop: '10px' }}>
                <Link to="/lost-password">Mot de passe oublié ?</Link>
            </p>
        </div>
    );
};

export default SignIn;
